import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import { Tooltip } from '@material-ui/core';
import Constant from '@/common/constant/Constant';

export default function EscalationEmailTicket({
    props,
    isHelpDesk,
    listTicketChild,
    viewFromProjectOfEscalateTicket,
    addNewPanel
}) {

    const viewTicketChildAndParent = async (ticketId, ticketOutline, isTicketChild) => {
        if (!ticketId) return;
        let type;
        let typeChatPanel;

        if (isHelpDesk) {
            if (isTicketChild) {
                type = Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;
                typeChatPanel = Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
            } else {
                type = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
                typeChatPanel = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
            }
        } else {
            if (!isTicketChild) {
                type = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
                typeChatPanel = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
            }
        }
        if (viewFromProjectOfEscalateTicket) {
            type = Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL;
            typeChatPanel = Constant.PANEL_TYPE.HELPDESK_CHATTHREAD;
        }

        if (!type) return;

        if (Utils.isEmptyString(ticketOutline)) {
            ticketOutline = '[概要 (現在未記入)]';
        }

        // open chat panel
        addNewPanel({
            //update
            type: typeChatPanel,
            tabId: ticketId,
            ticketId: ticketId,
            props,
            ticketOutline: ticketOutline,
            isShowAllChatPost: false
        });

        addNewPanel({
            //update
            type: type,
            tabId: ticketId,
            props,
            ticketId: ticketId,
            ticketOutline: ticketOutline
        });
    };

    return (
        <>
            <div className="form-addTicket" data-cy="detail-ticket-field">
                <label className="form-addTicket-label">{I18n.get('USER04LB016')}</label>
                <div className="form-addTicket-input">
                    <div className="lstLink">
                        <ul>
                            {listTicketChild?.map(
                                ticket =>
                                    ticket.id && (
                                        <li>
                                            <Tooltip
                                                title={
                                                    !Utils.isEmptyString(ticket?.outline)
                                                        ? ticket?.outline
                                                        : '[概要 (現在未記入)]'
                                                }
                                            >
                                                <div
                                                    className="ticket-link-detail"
                                                    onClick={() => {
                                                        viewTicketChildAndParent(
                                                            ticket?.id,
                                                            ticket?.outline,
                                                            true
                                                        );
                                                    }}
                                                >
                                                    {!Utils.isEmptyString(ticket?.outline)
                                                        ? ticket?.outline
                                                        : '[概要 (現在未記入)]'}
                                                </div>
                                            </Tooltip>
                                        </li>
                                    )
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
